<template>
    <div>
      <el-carousel height="2.9rem" :autoplay="true" :interval="5000">
        <el-carousel-item>
          <img src="../../assets/images/banner/product/donghua/1.jpg" width="100%" height="100%">
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/images/banner/product/donghua/2.jpg" width="100%" height="100%">
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/images/banner/product/donghua/3.jpg" width="100%" height="100%">
        </el-carousel-item>
      </el-carousel>
        <div class="box2">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
                <el-menu-item index="1" @click="$router.push('productSite')">智慧工地</el-menu-item>
                <el-menu-item index="2" @click="$router.push('productSafety')">智慧安全</el-menu-item>
                <el-menu-item index="3" @click="$router.push('productCartoon')">工程动画</el-menu-item>
            </el-menu>
        </div>
        <div class="box3">
            <div class="mar" v-for="(item,index) in dataList" :key="index">
                <div class="lef" v-if="index%2===0" @click="donClick(item.id)">
                    <span>{{item.title}}</span>
                    <i class="el-icon-arrow-right icon"></i>
                </div>
                <div class="lef bg" v-else @click="donClick(item.id)">
                    <span>{{item.title}}</span>
                    <i class="el-icon-arrow-right icon"></i>
                </div>
                <div class="bo" v-for="item2 in item.detail" :key="item2.id" @click="donClick(item2.id)">
                    <img :src="item2.img"  width="100%" height="100%">
                    <div>{{item2.text}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductSafety",
        data(){
            return{
                activeIndex: '3',
                dataList:[
                    {id:1,title: '建筑工程总承包',
                        detail: [
                            {id:1,img:require('../../assets/images/progd/cartoon/a1.jpg'),text:'深圳《平安国际金融中心》'},
                            {id:2,img:require('../../assets/images/progd/cartoon/a2.jpg'),text:'天津《周大福中心》'},
                            {id:3,img:require('../../assets/images/progd/cartoon/a3.jpg'),text:'深圳《腾讯滨海总部大厦》'},
                            {id:4,img:require('../../assets/images/progd/cartoon/a4.jpg'),text:'厦门《国际中心》'}]},
                    {id:5,title: '路、桥、隧、 地下空间',
                        detail: [
                            {id:5,img:require('../../assets/images/progd/cartoon/b1.jpg'),text:'《港珠澳大桥》投标动画'},
                            {id:6,img:require('../../assets/images/progd/cartoon/b2.jpg'),text:'深圳地铁盾构施工动画演示'},
                            {id:7,img:require('../../assets/images/progd/cartoon/b3.jpg'),text:'深圳地铁7、9号线施工动画演示'},
                            {id:8,img:require('../../assets/images/progd/cartoon/b4.jpg'),text:'隧道工程施工动画'}]},
                    {id:9,title: '水利枢纽、电力、港口码头',
                        detail: [
                            {id:9,img:require('../../assets/images/progd/cartoon/c1.jpg'),text:'港口码头施工动画演示'},
                            {id:10,img:require('../../assets/images/progd/cartoon/c2.jpg'),text:'湘江综合水利枢纽工程'},
                            {id:11,img:require('../../assets/images/progd/cartoon/c3.jpg'),text:'徐大堡核电厂施工动画演示'},
                            {id:12,img:require('../../assets/images/progd/cartoon/c4.jpg'),text:'南宁邕宁水利枢纽工程动画演示'}]},
                    {id:13,title: '工法、工艺、评优、报奖',
                        detail: [
                            {id:13,img:require('../../assets/images/progd/cartoon/d1.jpg'),text:'Z形幅超深地连墙施工工法'},
                            {id:14,img:require('../../assets/images/progd/cartoon/d2.jpg'),text:'国家级工法灌注工法'},
                            {id:15,img:require('../../assets/images/progd/cartoon/d3.jpg'),text:'伸缩缝施工国家级工法'},
                            {id:16,img:require('../../assets/images/progd/cartoon/d4.jpg'),text:'现浇连续箱梁满堂支架工法'}]},
                    {id:17,title: '无人机航拍、摄像、摄影',
                        detail: [
                            {id:17,img:require('../../assets/images/progd/cartoon/e1.jpg'),text:'顶级的飞手'},
                            {id:18,img:require('../../assets/images/progd/cartoon/e2.jpg'),text:'高端的设备'},
                            {id:19,img:require('../../assets/images/progd/cartoon/e3.jpg'),text:'一流的制作团队'},
                            {id:20,img:require('../../assets/images/progd/cartoon/e4.jpg'),text:'丰富的经验'}]},
                    {id:21,title: '安全警示片、安全教育定制',
                        detail: [
                            {id:21,img:require('../../assets/images/progd/cartoon/f1.jpg'),text:'安全生产警示片-物体打击案例'},
                            {id:22,img:require('../../assets/images/progd/cartoon/f2.jpg'),text:'安全生产警示片-高处坠落案例'},
                            {id:23,img:require('../../assets/images/progd/cartoon/f3.jpg'),text:'基坑坍塌施工事故动画模拟'},
                            {id:24,img:require('../../assets/images/progd/cartoon/f4.jpg'),text:'建筑施工安全生产警示片'}]},
                    {id:25,title: '工程观摩会视效创意',
                        detail: [
                            {id:25,img:require('../../assets/images/progd/cartoon/g1.jpg'),text:'270度全息幻影成像'},
                            {id:26,img:require('../../assets/images/progd/cartoon/g2.jpg'),text:'无人机航拍'},
                            {id:27,img:require('../../assets/images/progd/cartoon/g3.jpg'),text:'施工质量、安全等培训软件开发'},
                            {id:28,img:require('../../assets/images/progd/cartoon/g4.jpg'),text:'现场触摸屏系统展示'}]},
                    {id:29,title: '幕墙安装施工',
                        detail: [
                            {id:29,img:require('../../assets/images/progd/cartoon/h1.jpg'),text:'《央视大楼》幕墙动画'},
                            {id:30,img:require('../../assets/images/progd/cartoon/h2.jpg'),text:'深圳证券大厦幕墙施工动画'},
                            {id:31,img:require('../../assets/images/progd/cartoon/h3.jpg'),text:'《百度大厦》幕墙动画'},
                            {id:32,img:require('../../assets/images/progd/cartoon/h4.jpg'),text:'华润总部大厦'}]},
                ]
            }
        },
        methods:{
            donClick(id){
                sessionStorage.setItem('carCode',id);
                this.$router.push('cartoonDetail');
                document.documentElement.scrollTop=0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        height: 2.9rem;
        width: 100%;
        background: url("../../assets/images/dh.jpg");
        background-size: 100% 100%;
    }
    .box2{
        width: 6.24rem;
        margin: .34rem auto .6rem;
        text-align: center;
        a{
            text-decoration:none;
        }
        .el-menu-item{
            width:2.08rem;
            font-size: .2rem;
            height: .72rem;
            line-height: .72rem;
        }
        .el-menu--horizontal>.el-menu-item.is-active {
            border-bottom: 3px solid #E70F20;
            color: #E70F20;
        }
        .el-menu--horizontal>.el-menu-item {
            color:#000;
        }
    }
    .box3{
        width: 12rem;
        margin:0 auto 1rem;
        .mar{
            margin-bottom:.3rem;
            display: flex;
            div.lef{
                width:2.32rem;
                height:1.5rem;
                background: #EDF6FF;
                font-size: .22rem;
                text-align: center;
                padding-top:.4rem;
                position: relative;
                span{
                    padding-left: .2rem;
                    line-height: .36rem;
                    width: 1.88rem;
                    display: inline-block;
                    text-align: left;
                    position: relative;
                }
                span::before{
                    position: absolute;
                    top:.06rem;
                    left: 0;
                    width: 2px;
                    height: .22rem;
                    content:"";
                    background: #E70F20;

                }
                i.icon{
                    position: absolute;
                    bottom:.12rem;
                    right:.15rem;
                    font-size: .28rem;
                    color:#B5B5B5;
                }
            }
            div.bg{
                background: #FFEFED;
            }
            div.bo{
                position: relative;
                width:2.32rem;
                height:1.5rem;
                margin-left: .1rem;
                div{
                    position: absolute;
                    bottom:0;
                    left:0;
                    width:100%;
                    font-size: .14rem;
                    color:#fff;
                    text-align: center;
                    line-height: .26rem;
                    background: rgba(0,0,0,0.5);
                }
            }
            div.bo:hover{
                div{
                    top:0;
                    line-height: 1.5rem;
                }
            }
        }
    }
</style>
